import type { TopicsSummaryShellProps } from '@/modules/admin/pages/components/TopicsSummaryShell/TopicsSummaryShell.types'

import { TopicsSummary } from '@/components/@Shared/UserManagmentCharts/TopicsSummary/TopicsSummary'

import { useAdminStatsServiceAdminStatsControllerGetTopicsStats } from '@/__generated__/queries'

export function TopicsSummaryShell({
  company,
  onUpdateChartsData,
}: TopicsSummaryShellProps) {
  const { data, isFetching, isLoading } =
    useAdminStatsServiceAdminStatsControllerGetTopicsStats({
      company,
    })

  return (
    <TopicsSummary
      data={data}
      isLoading={isLoading || isFetching}
      onUpdateChartsData={onUpdateChartsData}
    />
  )
}
